import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/mobileMenu.js";
import { navigationItems } from "./navigationItems";
import HomeSectionLink from "./HomeSectionLink";
import logo from "../../assets/images/img1.jpg";
import { FiMenu, FiX } from "react-icons/fi";

const publicPath = (path) => process.env.PUBLIC_URL + path;

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    const media = window.matchMedia("(min-width: 992px)");
    const onResize = () => {
      if (media.matches) setIsOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    media.addEventListener("change", onResize);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      media.removeEventListener("change", onResize);
    };
  }, []);

  return (
    <Styles>
      <section className="mobile-menu-area">
        <Container>
          <Row>
            <Col xs="12">
              <div className="mb-topbar d-flex justify-content-between">
                <div className="topbar-item">
                  <p><i className="las la-phone"></i>+1 (905) 622 1221</p>
                </div>
                <div className="topbar-item">
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <Link to={publicPath("/login")}>Log In</Link>
                    </li>
                    <li className="list-inline-item">/</li>
                    <li className="list-inline-item">
                      <Link to={publicPath("/registration")}>Register</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-logo-area d-flex justify-content-between">
                <div className="mb-logo-box d-flex">
                  <div className="hm-button">
                    <button
                      className="mb-sidebar-trigger"
                      type="button"
                      aria-label="Open navigation menu"
                      aria-expanded={isOpen}
                      aria-controls="mobile-navigation"
                      onClick={() => setIsOpen(true)}
                    >
                      <FiMenu aria-hidden="true" /><span>Menu</span>
                    </button>
                  </div>
                  <div className="mb-logo">
                    <Link to={publicPath("/")}>
                      <img src={logo} alt="Study Concerns" />
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="mobile-navigation" aria-label="Mobile navigation" aria-hidden={!isOpen} className={`mb-sidebar${isOpen ? " opened" : ""}`}>
        <div className="mb-sidebar-heading d-flex justify-content-between">
          <h5>Menu</h5>
          <button type="button" aria-label="Close navigation menu" onClick={closeMenu}>
            <FiX aria-hidden="true" />
          </button>
        </div>
        <div className="mb-sidebar-menu">
          {navigationItems.map((item) => (
            <div className="mb-menu-item" key={item.label}>
              {item.children ? (
                <>
                  <button
                    className={`mb-menu-button${openMenu === item.label ? " active" : ""}`}
                    aria-expanded={openMenu === item.label}
                    type="button"
                    onClick={() => setOpenMenu(openMenu === item.label ? null : item.label)}
                  >
                    <p>{item.label}<i className="las la-plus"></i></p>
                  </button>
                  <div className={`mb-menu-content${openMenu === item.label ? " show" : ""}`}>
                    <ul className="list-unstyled">
                      {item.children.map((child) => (
                        <li key={`${item.label}-${child.label}`}>
                          <Link to={publicPath(child.path)} onClick={closeMenu}>
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : item.sectionId ? (
                <HomeSectionLink
                  className="mb-menu-link"
                  sectionId={item.sectionId}
                  onClick={closeMenu}
                >
                  {item.label}
                </HomeSectionLink>
              ) : (
                <Link className="mb-menu-link" to={publicPath(item.path)} onClick={closeMenu}>
                  {item.label}
                </Link>
              )}
            </div>
          ))}
          <div className="mb-menu-item">
            <Link className="mb-menu-link" to={publicPath("/apply")} onClick={closeMenu}>
              Apply Now
            </Link>
          </div>
        </div>
      </section>
      <button
        className={`mb-sidebar-overlay${isOpen ? " visible" : ""}`}
        type="button"
        aria-label="Close navigation menu"
        onClick={closeMenu}
      ></button>
    </Styles>
  );
}

export default MobileMenu;
